


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Player } from '@/models/Player';
import PlayingCard from '@/components/PlayingCard.vue';
import { PlayerRole } from '../models/PlayerRole';

@Component({
  components: {
    PlayingCard
  }
})
export default class PokerTable extends Vue {
  @Prop({ required: true }) players!: Player[];
  activePlayers: Player[] = [];

  // isMyPlayer(player: Player): boolean {
  //   return false; // this.roomStore.isMyPlayer(player); // todo: is this my player check
  // }

  @Watch('players', { deep: true })
  setActivePlayers() {
    this.activePlayers = this.players.filter(p => p.role === PlayerRole.Player);
  }
}
